import InspectionSelector from './src/main';

/* istanbul ignore next */
InspectionSelector.install = function(Vue) {
  Vue.component(InspectionSelector.name, InspectionSelector);
};

export default InspectionSelector;
